import React from "react";
import './styles.scss';

const Jumbotron = () => {
    return (
    <div className="jbzt-body">
        <div id="jbzt-dynamic-circle-right"></div>
        <div id="jbzt-dynamic-circle-down"></div>
        <div id="jbzt-dynamic-circle-left"></div>
        <div id="jbzt-ztlogo-div"><img src="/static/media/White 24.b0af6a8e.svg" alt="Logo" /></div>
        <div id="jbzt-logo-div"><img src="https://upload.wikimedia.org/wikipedia/en/thumb/2/21/Skuru_IK_logo.svg/340px-Skuru_IK_logo.svg.png" alt="Logo" /></div>
        <div className="zt-jumbotron">
            <div className="jbzt-header">
                <h1 className="bold">Köp 50/50-lotter i ZipperTic</h1>
                <h4>Clemensnäs HC - Vallentuna Hockey</h4>
            </div>
                <br /><br />
            <div className="jbzt-content">
                <p className="ztjb-text">Du kan vinna:    <strong>3212 kr.</strong></p>
            </div>
            <div className="jbzt-winner">
                <p className="ztjb-text">Vinnare:    <strong>Username Myname Secondname</strong></p>
            </div>
        </div>
    </div>
    );
};

Jumbotron.path = '/jumbotron';

export default Jumbotron;
